export default __webpack_public_path__ + "static/sv-7e159b96325de499bf774bfee0a468cd.svg";